import { Scenario, Category } from '../types';

export const navigateToNextTest = (
  currentCategory: string,
  currentScenario: Scenario | null,
  categories: Category[],
  onScenarioSelect: (scenario: Scenario) => void,
  selectedCategories?: string[]
) => {
  if (!currentCategory || !currentScenario) return;
  
  // Jeśli mamy wybrane kategorie, upewnij się, że aktualna kategoria jest wśród wybranych
  if (selectedCategories && selectedCategories.length > 0 && !selectedCategories.includes(currentCategory)) {
    return;
  }
  
  const currentCategoryScenarios = categories.find(cat => cat.name === currentCategory)?.scenarios;
  if (!currentCategoryScenarios) return;
  
  const currentIndex = currentCategoryScenarios.findIndex(
    scenario => scenario['ID testu'] === currentScenario['ID testu']
  );
  
  if (currentIndex < currentCategoryScenarios.length - 1) {
    onScenarioSelect(currentCategoryScenarios[currentIndex + 1]);
  } else if (selectedCategories && selectedCategories.length > 0) {
    // Jeśli to ostatni test w kategorii, przejdź do następnej wybranej kategorii
    const currentCategoryIndex = selectedCategories.indexOf(currentCategory);
    if (currentCategoryIndex < selectedCategories.length - 1) {
      const nextCategory = selectedCategories[currentCategoryIndex + 1];
      const nextCategoryScenarios = categories.find(cat => cat.name === nextCategory)?.scenarios;
      if (nextCategoryScenarios && nextCategoryScenarios.length > 0) {
        onScenarioSelect(nextCategoryScenarios[0]);
      }
    }
  }
};

export const navigateToPreviousTest = (
  currentCategory: string,
  currentScenario: Scenario | null,
  categories: Category[],
  onScenarioSelect: (scenario: Scenario) => void,
  selectedCategories?: string[]
) => {
  if (!currentCategory || !currentScenario) return;
  
  // Jeśli mamy wybrane kategorie, upewnij się, że aktualna kategoria jest wśród wybranych
  if (selectedCategories && selectedCategories.length > 0 && !selectedCategories.includes(currentCategory)) {
    return;
  }
  
  const currentCategoryScenarios = categories.find(cat => cat.name === currentCategory)?.scenarios;
  if (!currentCategoryScenarios) return;
  
  const currentIndex = currentCategoryScenarios.findIndex(
    scenario => scenario['ID testu'] === currentScenario['ID testu']
  );
  
  if (currentIndex > 0) {
    onScenarioSelect(currentCategoryScenarios[currentIndex - 1]);
  } else if (selectedCategories && selectedCategories.length > 0) {
    // Jeśli to pierwszy test w kategorii, przejdź do poprzedniej wybranej kategorii
    const currentCategoryIndex = selectedCategories.indexOf(currentCategory);
    if (currentCategoryIndex > 0) {
      const prevCategory = selectedCategories[currentCategoryIndex - 1];
      const prevCategoryScenarios = categories.find(cat => cat.name === prevCategory)?.scenarios;
      if (prevCategoryScenarios && prevCategoryScenarios.length > 0) {
        onScenarioSelect(prevCategoryScenarios[prevCategoryScenarios.length - 1]);
      }
    }
  }
}; 